// extracted by mini-css-extract-plugin
export var datePicker = "AsideCalendar-module--datePicker--slV56";